import APIV5 from '~/models/api';

export default class KformTabOpentextController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor($element) {
		/** @type {number} */
		this.folderId = 0;

		this.iframeElement = $element.find('iframe').get(0);

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;
	}

	async loadFolderWidget() {
		if (this.folderId !== null) {
			const result = await APIV5.instance.openText.getFolderWidget({ id: this.folderId });
			const blob = new window.Blob([result.buffer], { type: result.headers('Content-Type')?.toString() });
			const downloadUrl = URL.createObjectURL(blob);
			this.iframeElement?.setAttribute('src', downloadUrl);
		}
	}

	$onInit() {
		const repre = this.form?.getRepre('K_NODE;OPENTEXTID');
		if (repre) {
			this.folderId = Number.parseInt(repre.value, 10);
			(async() => this.loadFolderWidget())()
		}
	}
}
